import { BACKEND_URL } from "@/lib/constants/constants";

import axios from "../custom/axiosConfig";

export const downloadExportFile = async (id: string, exportType: string) => {
  const response = await axios({
    method: "get",
    url: `${BACKEND_URL}/datev/exports/buchungsdatenservice/${exportType}/${id}/download`,
    responseType: "blob",
  });

  // Create a URL for the blob
  const url = window.URL.createObjectURL(new Blob([response.data]));
  // Create a temporary anchor element and set its href to the blob URL
  const link = document.createElement("a");
  link.href = url;
  // Suggest a filename for the download
  const { day, month, year, hours, minutes } = getCurrentDate();
  link.setAttribute(
    "download",
    `buchungsdatenservice_${day}-${month}-${year}_${hours}${minutes}.zip`,
  );

  // Append the anchor to the body, click it, and remove it
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);

  window.URL.revokeObjectURL(url);
};

function getCurrentDate() {
  const currentDate = new Date();
  const year = currentDate.getFullYear();
  const month = (currentDate.getMonth() + 1).toString().padStart(2, "0"); // getMonth() is zero-based; add 1 to make it 1-indexed
  const day = currentDate.getDate().toString().padStart(2, "0");
  const hours = currentDate.getHours().toString().padStart(2, "0");
  const minutes = currentDate.getMinutes().toString().padStart(2, "0");
  return { day, month, year, hours, minutes };
}
